import * as Sentry from '@sentry/react';

const env = process.env.REACT_APP_ENV;
const sentryUrl = process.env.REACT_APP_SENTY_URL;

export default function sentryInit() {
	Sentry.init({
		dsn: sentryUrl,
		environment: env,
		sendDefaultPii: true
	});
}
